import {Interval} from "../../common/interval";
import {resolve} from "../../container";
import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../common/elements";

export const RELOAD_INTERVAL = 60 * 1000;

@customElement("eop-webcam-image")
export class EopWebcamImage extends UnLitElement {
    @property({attribute: "image-selector"})
    private imageSelector: string;
    @property()
    private src: string;

    private reloadPromise: Promise<void>;

    public constructor(private interval: Interval = resolve(Interval)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.reload();
        this.reloadPromise = this.interval.repeat(() => this.reload(), RELOAD_INTERVAL);
    }

    public disconnectedCallback(): void {
        this.interval.cancel(this.reloadPromise);
        super.disconnectedCallback();
    }

    private reload(): void {
        const imgElement = this.renderRoot.querySelector<HTMLImageElement>(this.imageSelector);
        if (imgElement) {
            imgElement.setAttribute("src", this.src + "?__random=" + Date.now());
        }
    }
}